import moment from "moment";
import { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { BsThreeDotsVertical, BsInfoCircle } from "react-icons/bs";
import { FcCalendar, FcDeleteRow } from "react-icons/fc";
import { MdOutlineDeleteForever } from "react-icons/md";
import { Table, Tag, Button, Dropdown } from "antd";
import { FaRegEdit } from "react-icons/fa";
import { FaEye } from "react-icons/fa6";
import { EditOutlined, DeleteOutlined, MoreOutlined } from "@ant-design/icons";
import toast from "react-hot-toast";
import axios from "../../../utils/axios";
import ViewPaymentPlan from "./modals/ViewPaymentPlan";
import { useSelector } from "react-redux";
import { channelController } from "../../../controllers/channelController";
import { errorBlock } from "../../../controllers/errorBlock";
import { CustomButton } from "../../CustomButton";
import { countryList } from "../../../helperFuncs/countryList";
import { GoInfinity } from "react-icons/go";

const TieredPlanTable = ({ data, loading, refreshbtn, tabstate }) => {
  const [plandetails, setplandetails] = useState({});
  const [deleting, setdeleting] = useState(false);
  const [selectplan, setselectplan] = useState({});
  const [open, setopen] = useState(false);
  const { siteid, sitename, country } = useSelector(
    (state) => state.projectSite
  );

  const deletePlan = async (item) => {
    try {
      setdeleting(true);
      let res = await axios.post("/vending/paymentplan/deletepaymentplan", {
        planalias: item.planalias,
        customerclass: item.meter_class,
        siteid: Number(siteid),
      });

      let result = channelController(res);

      if (result.type != "success") {
        toast.error(result.message);
        setdeleting(false);
        return;
      }
      toast.success("Plan deleted successfully.");
      setdeleting(false);
      refreshbtn((prev) => !prev);
    } catch (err) {
      errorBlock(err);
      setdeleting(false);
    }
  };

  // Function to get color for customer class tags
  const getCustomerClassColor = (customerClass) => {
    const colorMap = {
      residential: "blue",
      commercial: "green",
      industrial: "orange",
      government: "purple",
      default: "default",
    };
    return colorMap[customerClass?.toLowerCase()] || colorMap.default;
  };

  const handleEdit = (record) => {
    // Add your edit logic here
    console.log("Edit record:", record);
    toast.info("Edit functionality to be implemented");
  };

  const columns = [
    {
      title: "Sitename",
      dataIndex: "sitename",
      key: "sitename",
      align: "center",
      hidden: tabstate === 1,
      render: (sitename) => (
        <div className="text-secondary font-semibold">{sitename}</div>
      ),
    },
    {
      title: "Set by",
      dataIndex: "set_by",
      key: "set_by",
      align: "center",
    },
    {
      title: "Date Created",
      dataIndex: "date_set",
      key: "date_set",
      align: "center",
      sorter: true,
      render: (date_set) => (
        <div className="flex items-center justify-center">
          <div className="text-xs">
            {moment(date_set).format("YYYY-MM-DD HH:mm:ss")}
          </div>
        </div>
      ),
    },
    {
      title: "Customer Class",
      dataIndex: "customer_class",
      key: "customer_class",
      align: "center",
      render: (customer_class) => (
        <Tag
          color={getCustomerClassColor(customer_class)}
          className="capitalize"
        >
          {customer_class}
        </Tag>
      ),
    },
    // {
    //   title: "Actions",
    //   key: "actions",
    //   align: "center",
    //   hidden: tabstate === 2,
    //   render: (_, record) => (
    //     <div className="flex items-center justify-center gap-2">
    //       <Button
    //         type="text"
    //         icon={null}
    //         onClick={() => handleEdit(record)}
    //         className="text-blue-600 hover:text-blue-800"
    //         size="small"
    //       >
    //         Edit
    //       </Button>
    //     </div>
    //   ),
    // },
  ].filter((column) => !column.hidden);

  const expandedColumns = [
    {
      title: "From (units)",
      dataIndex: "min_units",
      key: "min_units",
      align: "center",
    },
    {
      title: "To (units)",
      dataIndex: "max_units",
      key: "max_units",
      align: "center",
      render: (max_units) => (
        <div>
          {max_units == null ? (
            <div className="flex items-center justify-center">
              <GoInfinity size={18} />
            </div>
          ) : (
            max_units
          )}
        </div>
      ),
    },
    {
      title: `Price per kWh (${countryList[country]["Currency Code"]})`,
      dataIndex: "price_per_kWh",
      key: "price_per_kWh",
      align: "center",
    },
  ];

  const ExpandedComponent = ({ record }) => (
    <div className="w-[60%] my-2 mx-auto border">
      <div className="p-2 border-b">
        <h2 className="font-semibold">
          {tabstate === 1 ? `Price tiers` : <>Tiered</>}
        </h2>
      </div>

      <Table
        columns={expandedColumns}
        dataSource={record?.pricing_tiers?.tiers}
        pagination={false}
        loading={loading}
        size="small"
        rowKey={(record, index) => index}
      />
    </div>
  );

  return (
    <>
      {open && (
        <ViewPaymentPlan open={open} setopen={setopen} details={plandetails} />
      )}
      <Table
        columns={columns}
        dataSource={data}
        pagination={{
          pageSize: 10,
          showSizeChanger: false,
          showQuickJumper: true,
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} of ${total} items`,
        }}
        loading={loading}
        size="small"
        rowKey={(record) => record.planalias || record.id}
        scroll={{ x: 800 }}
        expandable={{
          expandedRowRender: (record) => <ExpandedComponent record={record} />,
          rowExpandable: (record) => record?.pricing_tiers?.tiers?.length > 0,
        }}
      />
    </>
  );
};

export default TieredPlanTable;
